import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IModalContent, IModalState, TOfferType, EModalType } from '../../types';

export const initialState: IModalState = {
  isOpen: false,
  content: null,
  type: EModalType.BANK,
};

export interface IOpenModalPayloadAction {
  content: IModalContent | null;
  type: TOfferType | null;
}

/* istanbul ignore next */
export const modalSlice = createSlice({
  initialState,
  name: 'modal',
  reducers: {
    openModal: (state, { payload: { content, type } }: PayloadAction<IOpenModalPayloadAction>) => {
      state.isOpen = true;
      state.content = content;
      state.type = type;
    },
    closeModal: state => {
      state.isOpen = false;
      state.content = null;
      state.type = null;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
